import * as qs from 'query-string';

/**
 * Parse `?regionID=` from an Invite Tech signup URL.
 * Rejects path-like values so they cannot be used as a Firestore doc path.
 */
export function inviteRegionIdFromSearch(search: string): string {
    const { regionID } = qs.parse(search || '');
    const raw = Array.isArray(regionID) ? regionID[0] : regionID;
    if (typeof raw !== 'string') return '';
    const id = raw.trim();
    if (!id || id.includes('/') || id.includes('\\')) return '';
    return id;
}
